<template>
	<div class="status-list">
		<template v-for="(item, index) of list">
			<status-item :title="item.title" :content="item.content" :image="item.image" />
			<template v-if="index < list.length - 1">
				<img v-if="index === list.length - 2" src="@/assets/svg/line_separator.svg" />
				<img v-else src="@/assets/svg/arrow_up.svg" />
			</template>
		</template>
	</div>
</template>

<script>
import StatusItem from '@/views/my-page/order-delivery/order/components/StatusItem.vue'

export default {
	name: 'StatusList',
	components: {
		StatusItem,
	},
	props: {
		list: {
			type: Array,
			default: () => [],
		},
	},
}
</script>

<style lang="scss" scoped>
.status-list {
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	img {
		padding-top: 60px;
	}
}
</style>
